import { maxItemCount } from '@/consts/limits';


export default function checkItemCount(val: string | number, oldVal: number) {
    return isNaN(+val) ? oldVal : +val > 0 ? (+val <= maxItemCount ? +val : maxItemCount) : 1;
}